module.exports = __webpack_public_path__ + "ec5a26d3645c8bee4d17f49cf4066081.svg";